import React from 'react';
import { BlockBody, EmptyBlockContent } from '@tradingblock/components';
import { BlockType } from '@tradingblock/types';
import { AccountTransferContent } from './AccountTransferContent';
import { Block } from '../../components/blocks/Block';
import { getBlockProps } from '../../utilities/block';
import { useStateSelector } from '../../data/global/dataSelectors';
import { account } from '../../data/global/selectors/accountSelectors';
import { useMemo } from 'react';
import AccountTransferNotSupportedContent from './AccountTransferNotSupportedContent';
import { useClearer } from '../../hooks/useClearer';

export const AccountTransferBlock: React.FunctionComponent<{}> = () => {
  const accountType = useStateSelector(account.type);
  const clearer = useClearer();
  const isRQD = clearer === 'RQD';

  //Loads cashiering only on supported accounts TBFE-116 should resolve this code better
  const blockContent = useMemo(() => {
    if (accountType === undefined) {
      return <></>;
    }

    return <AccountTransferContent />;
  }, [accountType, isRQD]);
  return (
    <Block {...getBlockProps(BlockType.AccountTransfer)}>
      <BlockBody>{blockContent}</BlockBody>
    </Block>
  );
};
